/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Badge_PremiumInputs */

const en_model_badge_premium = /** @type {(inputs: Model_Badge_PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const id_model_badge_premium = /** @type {(inputs: Model_Badge_PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

/**
* | output |
* | --- |
* | "Premium" |
*
* @param {Model_Badge_PremiumInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_badge_premium = /** @type {((inputs?: Model_Badge_PremiumInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Badge_PremiumInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_badge_premium(inputs)
	return en_model_badge_premium(inputs)
});